import React, {useState} from 'react';

const IOSSwitch = ({label, checked, defaultChecked = false, onChange, hideLabel = false, disabled = false}) => {
    const [enabled, setEnabled] = useState(checked !== undefined ? checked : defaultChecked);

    // Update internal state when checked prop changes
    React.useEffect(() => {
        if (checked !== undefined) {
            setEnabled(checked);
        }
    }, [checked]);

    const handleToggle = () => {
        if (disabled) return;
        const newValue = !enabled;
        setEnabled(newValue);
        if (onChange) {
            onChange(newValue);
        }
    };

    return (
        <div className="flex items-center">
            <button
                type="button"
                role="switch"
                aria-checked={enabled}
                aria-label={label || "Toggle"}
                onClick={handleToggle}
                disabled={disabled}
                className={`
                    ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
                    relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2
                    border-transparent transition-colors duration-200 ease-in-out
                    focus:outline-none focus:primary-2 focus:ring-primary-500 focus:primary-offset-2
                    ${enabled ? 'bg-primary' : 'bg-gray-200 dark:bg-gray-600'}
                `}
            >
                <span className="sr-only">{label || "Toggle"}</span>
                <span
                    className={`
                        pointer-events-none inline-block h-5 w-5 transform rounded-full
                        bg-white shadow ring-0 transition duration-200 ease-in-out
                        ${enabled ? 'translate-x-5' : 'translate-x-0'}
                    `}
                />
            </button>
            {label && !hideLabel && (
                <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{label}</span>
            )}
        </div>
    );
};

export default IOSSwitch;
